import { render, staticRenderFns } from "./VehiculoNvo.vue?vue&type=template&id=169bd1a4&"
import script from "./VehiculoNvo.vue?vue&type=script&lang=js&"
export * from "./VehiculoNvo.vue?vue&type=script&lang=js&"
import style0 from "./VehiculoNvo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports